import { Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import BottomMenu from "../components/BottomMenu";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import "../styles/App.css";
import { useState, useEffect } from "react";

function Layout() {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hideOnRoutes = ["/login"];

  useEffect(() => {
    //console.log("isModalOpen en Layout:", isModalOpen);
  }, [isModalOpen]);

  //console.log("Render Layout, isModalOpen:", isModalOpen);

  return (
    <div className="app-container">
      {/* Sidebar fijo */}
      <Sidebar />

      {/* Contenido principal */}
      <main className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard setIsModalOpen={setIsModalOpen} modo="dashboard" />} />
          {/* aquí puedes agregar más rutas */}
        </Routes>
      </main>


      {!hideOnRoutes.includes(location.pathname) && !isModalOpen && (
        <BottomMenu />
      )}

    </div>
  );
}

export default Layout;
